
(function ($) {

	var $processicon1 = $("path#processicon1");
	var $arrowleftline1 = $("path#arrowleftline1");
		var $arrowleftpointer1 = $(".arrowleftpointer1");

	var $processicon2 = $("path#processicon2");
	var $arrowrightline1 = $("path#arrowrightline1");
		var $arrowrightpointer1 = $(".arrowrightpointer1");

	var $processicon3 = $("path#processicon3");
	var $arrowleftline2 = $("path#arrowleftline2");
		var $arrowleftpointer2 = $(".arrowleftpointer2");

	var $processicon4 = $("path#processicon4");
	var $arrowrightline2 = $("path#arrowrightline2");
		var $arrowrightpointer2 = $(".arrowrightpointer2");

	var $processicon5 = $("path#processicon5");
	var $arrowleftline3 = $("path#arrowleftline3");
		var $arrowleftpointer3 = $(".arrowleftpointer3");

	var $processicon6 = $("path#processicon6");
	var $arrowrightline3 = $("path#arrowrightline3");
		var $arrowrightpointer3 = $(".arrowrightpointer3");

	var $processicon7 = $("path#processicon7");


	// init controller
	var controller = new ScrollMagic.Controller();

	// build tween
	var selftween = new TimelineMax()
		.add(TweenMax.to($processicon1, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon1, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);
	
	var applicationtween = new TimelineMax()
		.add(TweenMax.to($arrowleftline1, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowleftline1, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowleftpointer1, 1, {opacity:1}))
		.add(TweenMax.to($processicon2, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon2, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);

	var assessmenttween = new TimelineMax()
		.add(TweenMax.to($arrowrightline1, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowrightline1, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowrightpointer1, 1, {opacity:1}))
		.add(TweenMax.to($processicon3, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon3, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);

	var assignedtween = new TimelineMax()
		.add(TweenMax.to($arrowleftline2, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowleftline2, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowleftpointer2, 1, {opacity:1}))
		.add(TweenMax.to($processicon4, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon4, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);

	var certificatetween = new TimelineMax()
		.add(TweenMax.to($arrowrightline2, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowrightline2, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowrightpointer2, 1, {opacity:1}))
		.add(TweenMax.to($processicon5, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon5, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);

	var bartween = new TimelineMax()
		.add(TweenMax.to($arrowleftline3, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowleftline3, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowleftpointer3, 1, {opacity:1}))
		.add(TweenMax.to($processicon6, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon6, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);

	var careertween = new TimelineMax()
		.add(TweenMax.to($arrowrightline3, .7, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($arrowrightline3, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0)
		.add(TweenMax.to($arrowrightpointer3, 1, {opacity:1}))
		.add(TweenMax.to($processicon7, 2, {strokeDashoffset: 0, ease:Linear.easeNone}))
		.add(TweenMax.to($processicon7, .5, {stroke: "#0079C2", ease:Linear.easeNone}), 0);
	
	// build assessment
	var selficontween = new ScrollMagic.Scene({triggerElement: "#self-assessment", duration: 200, tweenChanges: true})
					.setTween(selftween)
					.addTo(controller);

	// build application
	var appicontween = new ScrollMagic.Scene({triggerElement: "#application", duration: 200, tweenChanges: true})
					.setTween(applicationtween)
					.addTo(controller);

	// build assessment
	var assicontween = new ScrollMagic.Scene({triggerElement: "#assessment-process", duration: 200, tweenChanges: true})
					.setTween(assessmenttween)
					.addTo(controller);

	// build application
	var assignedicontween = new ScrollMagic.Scene({triggerElement: "#assigned-requirements", duration: 200, tweenChanges: true})
					.setTween(assignedtween)
					.addTo(controller);
	
	// build assessment
	var certicontween = new ScrollMagic.Scene({triggerElement: "#certificate-of-qualification", duration: 200, tweenChanges: true})
					.setTween(certificatetween)
					.addTo(controller);

	// build application
	var baricontween = new ScrollMagic.Scene({triggerElement: "#bar-admissions", duration: 200, tweenChanges: true})
					.setTween(bartween)
					.addTo(controller);		

	// build application
	var careericontween = new ScrollMagic.Scene({triggerElement: "#career-options", duration: 200, tweenChanges: true})
					.setTween(careertween)
					.addTo(controller);				


})(jQuery);

